import * as tslib_1 from "tslib";
import { EffectEnvMapMethod } from "./EffectEnvMapMethod";
/**
 * EffectRefractionEnvMapMethod provides a method to add refracted transparency based on cube maps.
 */
var EffectRefractionEnvMapMethod = (function (_super) {
    tslib_1.__extends(EffectRefractionEnvMapMethod, _super);
    /**
     * Creates a new EffectRefractionEnvMapMethod object. Example values for dispersion are: dispersionR: -0.03, dispersionG: -0.01, dispersionB: = .0015
     *
     * @param envMap The environment map containing the refracted scene.
     * @param refractionIndex The refractive index of the material.
     * @param dispersionR The amount of chromatic dispersion of the red channel. Defaults to 0 (none).
     * @param dispersionG The amount of chromatic dispersion of the green channel. Defaults to 0 (none).
     * @param dispersionB The amount of chromatic dispersion of the blue channel. Defaults to 0 (none).
     */
    function EffectRefractionEnvMapMethod(envMap, alpha, refractionIndex, dispersionR, dispersionG, dispersionB) {
        if (alpha === void 0) { alpha = 1; }
        if (refractionIndex === void 0) { refractionIndex = .1; }
        if (dispersionR === void 0) { dispersionR = 0; }
        if (dispersionG === void 0) { dispersionG = 0; }
        if (dispersionB === void 0) { dispersionB = 0; }
        var _this = _super.call(this, envMap, alpha) || this;
        _this._dispersionR = 0;
        _this._dispersionG = 0;
        _this._dispersionB = 0;
        _this._refractionIndex = refractionIndex;
        _this._dispersionR = dispersionR;
        _this._dispersionG = dispersionG;
        _this._dispersionB = dispersionB;
        return _this;
    }
    Object.defineProperty(EffectRefractionEnvMapMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return EffectRefractionEnvMapMethod.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EffectRefractionEnvMapMethod.prototype, "refractionIndex", {
        /**
         * The refractive index of the material.
         */
        get: function () {
            return this._refractionIndex;
        },
        set: function (value) {
            this._refractionIndex = value;
            this.invalidate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EffectRefractionEnvMapMethod.prototype, "dispersionR", {
        /**
         * The amount of chromatic dispersion of the red channel. Defaults to 0 (none).
         */
        get: function () {
            return this._dispersionR;
        },
        set: function (value) {
            if (this._dispersionR == value)
                return;
            this._dispersionR = value;
            this.invalidateShaderProgram();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EffectRefractionEnvMapMethod.prototype, "dispersionG", {
        /**
         * The amount of chromatic dispersion of the green channel. Defaults to 0 (none).
         */
        get: function () {
            return this._dispersionG;
        },
        set: function (value) {
            if (this._dispersionG == value)
                return;
            this._dispersionG = value;
            this.invalidateShaderProgram();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EffectRefractionEnvMapMethod.prototype, "dispersionB", {
        /**
         * The amount of chromatic dispersion of the blue channel. Defaults to 0 (none).
         */
        get: function () {
            return this._dispersionB;
        },
        set: function (value) {
            if (this._dispersionB == value)
                return;
            this._dispersionB = value;
            this.invalidateShaderProgram();
        },
        enumerable: true,
        configurable: true
    });
    return EffectRefractionEnvMapMethod;
}(EffectEnvMapMethod));
export { EffectRefractionEnvMapMethod };
EffectRefractionEnvMapMethod.assetType = "[asset EffectRefractionEnvMapMethod]";



// WEBPACK FOOTER //
// ../dist/lib/methods/EffectRefractionEnvMapMethod.js